
// src/helpers/analytics.js

import React from 'react'
import mixpanel from './mixpanel'
import config from '../config'

config.mixpanelToken && mixpanel.init(config.mixpanelToken)

var user_id, account_id

export function setId(_user_id, _account_id) {
  user_id = _user_id
  account_id = _account_id
}

export function track(event, opts = {}) {
  config.mixpanelToken && mixpanel.track(
    event,
    Object.assign({}, opts, { distinct_id: user_id, account_id: account_id })
  )
}

export function trackPage(event) {
  return function (Component) {
    class TrackComponent extends React.Component {
      componentDidMount() {
        track(event)
      }

      render () {
        return <Component {...this.props} />
      }
    }

    TrackComponent.displayName = `TrackPage(${Component.displayName})`
    return TrackComponent
  }
}

export function trackHandlers(name, event, opts = {}) {
  return function (Component) {
    class TrackComponent extends React.Component {
      constructor(props) {
        super(props)

        this._mergeProps = {}
        this._mergeProps[name] = (...params)=> {
          track(event, opts, { distinct_id: user_id, account_id: account_id })
          this.props[name](...params)
        }
      }

      render () {
        var props = Object.assign({}, this.props, this._mergeProps)
        return <Component {...props} />
      }
    }

    TrackComponent.displayName = `TrackHandlers(${Component.displayName || Component.name})`
    return TrackComponent
  }
}



// WEBPACK FOOTER //
// ./src/helpers/analytics.js